// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/i18n/terminology.ts

export const TERMINOLOGY = Object.freeze({
  askButton: { upper: 'Ask' },
  editButton: { upper: 'Edit' },
  reference: { lower: 'reference', lowerPlural: 'references', upper: 'Reference', upperPlural: 'References' },
  task: { lower: 'task', upper: 'Task', lowerPlural: 'tasks', upperPlural: 'Tasks' },
  project: { lower: 'project', upper: 'Project', lowerPlural: 'projects', upperPlural: 'Projects' },
  changeTemplate: {
    lower: 'change template',
    upper: 'Change template',
    lowerPlural: 'change templates',
    upperPlural: 'Change templates',
  },
  block: {
    // "Block" is used in the codebase to refer to reusable content/snippet.
    lower: 'reusable content',
    upper: 'Reusable content',
  },
  inlineBlock: {
    // "Inline block" is used in the codebase to refer to reusable content/snippet.
    lower: 'reusable snippet',
    upper: 'Reusable snippet',
  },
  template: {
    lower: 'template',
    lowerPlural: 'templates',
    upper: 'Template',
    upperPlural: 'Templates',
  },
  blockEither: {
    // "Block" is used in the codebase to refer to reusable content/snippet.
    lower: 'reusable content/snippet',
    upper: 'Reusable content/snippet',
  },

  database: {
    lower: 'library',
    upper: 'Library',
  },
  productDatabase: {
    lower: 'product library',
    upper: 'Product library',
  },
  qmDatabase: {
    lower: 'global library',
    upper: 'Global library',
  },
  qualityManagement: {
    lower: 'quality management',
    upper: 'Quality management',
  },
  product: {
    lower: 'product',
    upper: 'Product',
    lowerPlural: 'products',
    upperPlural: 'Products',
  },
  technicalDocumentation: {
    lower: 'technical documentation',
    upper: 'Technical documentation',
  },
  jurisdiction: {
    lower: 'jurisdiction',
    upper: 'Jurisdiction',
  },
  folder: {
    lower: 'folder',
    upper: 'Folder',
  },

  registrationFull: {
    lower: 'country registrations',
    upper: 'Country registrations',
  },
  registrationCountry: {
    lower: 'country',
    upper: 'Country',
    lowerPlural: 'countries',
    upperPlural: 'Countries',
  },
  registrationSingle: {
    lower: 'registration',
    upper: 'Registration',
    lowerPlural: 'registrations',
    upperPlural: 'Registrations',
  },

  // snapshots terminology:
  snapshots: {
    lower: 'snapshots',
    upper: 'Snapshots',
  },
  snapshot: {
    lower: 'snapshot',
    upper: 'Snapshot',
  },
  snapshotCollection: {
    lower: 'snapshot collection',
    upper: 'Snapshot collection',
  },

  // replicas/synchronization terminology:
  replica: {
    // "Replica" is used in the codebase to refer to a synced copy of a document/file.
    lower: 'synced copy',
    lowerPlural: 'synced copies',
    upper: 'Synced copy',
    upperPlural: 'Synced copies',
  },
  master: {
    // "Master" is used in the codebase to refer to the source document/file of a replica.
    lower: 'source',
    upper: 'Source',
  },
  synchronize: {
    lower: 'synchronize',
    upper: 'Synchronize',
  },
  synchronized: {
    lower: 'synced',
    upper: 'Synced',
  },

  // template binding mode terminology:
  bound: {
    lower: 'fixed',
    upper: 'Fixed',
  },
  detached: {
    lower: 'editable',
    upper: 'Editable',
  },

  // frozen/locked terminology:
  freeze: {
    lower: 'lock',
    upper: 'Lock',
  },
  frozen: {
    lower: 'locked',
    upper: 'Locked',
  },
  unfreeze: {
    lower: 'unlock',
    upper: 'Unlock',
  },
  unfrozen: {
    lower: 'unlocked',
    upper: 'Unlocked',
  },

  // literature terminology:
  literature: {
    lower: 'literature',
    upper: 'Literature',
  },

  // `as const` tells TypeScript to treat e.g. 'Reusable content' as the literal type "Reusable content", not a generic string.
} as const);
